import React, {useMemo} from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {compose} from 'recompose'
import {withAuthenticationRequirement} from 'lib/hoc'
import { Route, Switch, Redirect } from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import Sidetabs from './Sidetabs'
import {Box, H1, Text, Loading} from 'components'
import MobilepayAgreement from './Mobilepay/Agreement'
import KevinAgreement from './Kevin/KevinAgreement'
import MobilepaySubscriptionAgreement from './MobilepaySubscription/MobilepaySubscriptionAgreement'
import MobilepayClubDirectSubscriptionAgreement from './mobilePayClubDirectSubscription/MobilepayClubDirectSubscriptionAgreement'
import {getActive} from 'clubs/selectors'
import {getCompanyName} from 'app/selectors'
import {
  Settings as SettingsIcon,
  Integrations as IntegrationsIcon,
  Payment as PaymentIcon,
  Association as AssociationIcon,
  People as PeopleIcon,
} from 'components/icons'
import { useFeature } from "@growthbook/growthbook-react";
import { module_payment_mobilepay, module_payment_mobilepaysubscription } from 'globalModuleNames';

const PaymentMethods = ({club, match: {path}}) => {
  const [t] = useTranslation()

  const tabs = useMemo(
      () => {

        let paymentMethodTabs = [
          {
            id: 'kevin',
            name: t('MinForening Betalingsløsning (0% i transaktionsgebyr) Obs! Sat på pause - afventer godkendelse fra EU'),
            icon: PaymentIcon,
          },
        ];

        if (useFeature(module_payment_mobilepay).on) {
          paymentMethodTabs.push(
            {
              id: 'mobilepay',
              name: t('MobilePay Payments (1% i transaktionsgebyr)'),
              icon: PaymentIcon,
            }
          )
        }

        if (useFeature(module_payment_mobilepaysubscription).on) {
          paymentMethodTabs.push({
            id: 'mobilePaySubscription',
            name: t('MobilePay Subscription (1% i transaktionsgebyr, dog mindst 1 kr. og maks. 2.75 kr.)'),
            icon: PaymentIcon,
          });
        }


        return paymentMethodTabs;
      },
      [t, club]
    )

  return (
      <>
          <H1>{t('Vælg betalingsmetode')}</H1>
          <br />
          <Sidetabs tabs={tabs}>
              <Switch>
                  <Route path={`${path}/mobilepay`} component={MobilepayAgreement} />                  
                  <Route path={`${path}/kevin`} component={KevinAgreement} />
                  {useFeature(module_payment_mobilepaysubscription).on &&
                    <Route path={`${path}/mobilepaySubscription`} component={MobilepaySubscriptionAgreement} />
                  }
                  
                  {/* Upcomming paymentMethod!! */}
                  {/* <Route path={`${path}/mobilepayClubDirectSubscription`} component={MobilepayClubDirectSubscriptionAgreement} /> */}
                  <Route render={() => <Redirect to={path} />} />                  
              </Switch>
          </Sidetabs>
      </>
  )}

  const enhancer = compose(
    withAuthenticationRequirement,
    connect(
      createStructuredSelector({
        companyName: getCompanyName,
        club: getActive,
      })
    )
  )
  
export default enhancer(PaymentMethods)
